<template>
  <v-app>
    <v-content>
      <v-app-bar class="px-8" height="100" color="white" elevation="10">
        <v-img src="./assets/logo.png" max-height="100" max-width="100"></v-img>
        <v-tabs class="hidden-sm-and-down" right color="accent" hide-slider>
          <v-tab to="/" optional>Home</v-tab>
          <v-tab to="/book" optional>Book Clubhouse</v-tab>
        </v-tabs>
        <v-menu right>
          <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon class="hidden-md-and-up" v-on="on" slot="activator"></v-app-bar-nav-icon>
          </template>
          <v-list class="d-flex flex-column">
            <v-list-item to="/">
              <v-list-item-content>
                <v-list-item-title>Home</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/book">
              <v-list-item-content>
                <v-list-item-title>Book Clubhouse</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <div class="content-container">
        <router-view />
      </div>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  })
};
</script>

<style scoped>
.content-container {
  background-color: rgb(76, 175, 80, 0.7);
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

::v-deep .v-toolbar__content {
  display: flex;
  justify-content: space-between;
}
</style>
